export default {
  // Campaigns 模块
  'HOME.CAMPAIGNS.TITLE': '最近活动效果',
  'HOME.CAMPAIGNS.GO': '活动报表',
  'HOME.CAMPAIGNS.LABEL.NAME': '活动名称',
  'HOME.CAMPAIGNS.LABEL.TIME': '投递时间',
  'HOME.CAMPAIGNS.LABEL.CIRCLE': '周期',
  'HOME.CAMPAIGNS.NUM.1': '已发送',
  'HOME.CAMPAIGNS.NUM.DESC.1': '已发送的邮件的数量',
  'HOME.CAMPAIGNS.NUM.2': '已送达',
  'HOME.CAMPAIGNS.NUM.DESC.2': '已成功送达用户邮箱服务器的邮件数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.2': '送达率',
  'HOME.CAMPAIGNS.PERCENT.DESC.2': '送达率 = 送达量/已发送',
  'HOME.CAMPAIGNS.NUM.3': '打开量',
  'HOME.CAMPAIGNS.NUM.DESC.3': '被用户打开的邮件数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.3': '打开率',
  'HOME.CAMPAIGNS.PERCENT.DESC.3': '打开率 = 打开量/送达量',
  'HOME.CAMPAIGNS.NUM.4': '取消订阅量',
  'HOME.CAMPAIGNS.NUM.DESC.4': '此活动中取消订阅的数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.4': '退订率',
  'HOME.CAMPAIGNS.PERCENT.DESC.4': '退订率 = 取消订阅量/送达量',
  'HOME.CAMPAIGNS.NUM.5': '注册用户量',
  'HOME.CAMPAIGNS.NUM.DESC.5': '投递后，投递用户注册游戏的数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.5': '注册率',
  'HOME.CAMPAIGNS.PERCENT.DESC.5': '注册率 = 注册数/送达量',
  'HOME.CAMPAIGNS.NUM.6': '活跃用户量',
  'HOME.CAMPAIGNS.NUM.DESC.6': '投递后，投递用户注册游戏的数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.6': '活跃率',
  'HOME.CAMPAIGNS.PERCENT.DESC.6': '活跃率 = 活跃数/送达量',
  'HOME.CAMPAIGNS.NUM.7': '付费用户量',
  'HOME.CAMPAIGNS.NUM.DESC.7': '投递后，投递用户游戏内付费的数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.7': '付费率',
  'HOME.CAMPAIGNS.PERCENT.DESC.7': '付费率 = 付费数/送达量',
  'HOME.CAMPAIGNS.NUM.8': '点击量',
  'HOME.CAMPAIGNS.NUM.DESC.8': '链接被点击的邮件数量',
  'HOME.CAMPAIGNS.PERCENT.TITLE.8': '点击率',
  'HOME.CAMPAIGNS.PERCENT.DESC.8': '点击率 = 点击量/送达量',
  'HOME.CAMPAIGNS.NUM.10': '收件人',
  'HOME.CAMPAIGNS.NUM.DESC.10': '活动设置的收件人数量',
  // Subscribers 模块
  'HOME.SUBSCRIBERS.TITLE': '订阅用户总量',
  'HOME.SUBSCRIBERS.DESC.ADD':
    '最近一周增加了<span class="color-primary">{num}</span>个订阅者',
  'HOME.SUBSCRIBERS.DESC.REDUCE':
    '最近一周减少了<b class="color-primary">{num}</b>个订阅者',
  'HOME.SUBSCRIBERS.DESC.NO.CHANGE': '<span>最近一周无变化</span>',
  'HOME.SUBSCRIBERS.GO': '查看详情',
  // Regional and language distribution of subscribers 模块
  'HOME.SUBSCRIBERSANDLANGUAGE.TITLE': '订阅用户分布',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.REGION': '按区域',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.LANGUAGE': '按语言',
  'HOME.SUBSCRIBERSANDLANGUAGE.BY.PREFERENCE': '按用户偏好',
  'HOME.SUBSCRIBERSANDLANGUAGE.PREFERENCE': '偏好',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS': '其他',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.NAME': '区域',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.VALUE': '订阅用户',
  'HOME.SUBSCRIBERSANDLANGUAGE.OTHERS.HEADER.PERCENT': '整体占比',
  // 偏好饼图查询 未设置偏好
  'HOME.SUBSCRIBERS.PREFERENCE.NOTSET': '未设置偏好',

  // ToDoList 模块
  'HOME.TODOLIST.TITLE': '待办事项',
  'HOME.TODOLIST.QUICKSETUP': '快速设置',
  'HOME.TODOLIST.QUICKSETUP.1': '域名验证',
  'HOME.TODOLIST.QUICKSETUP.1.DESC': '认证你的发件域名身份',
  'HOME.TODOLIST.QUICKSETUP.2': '常用发件地址',
  'HOME.TODOLIST.QUICKSETUP.2.DESC':
    '设置常用发件地址，以便在创建活动时快速引用',
  'HOME.TODOLIST.QUICKSETUP.3': '常用发件人名称',
  'HOME.TODOLIST.QUICKSETUP.3.DESC':
    '设置常用发件人，以便订阅者可以识别，比如你的游戏名称',
  'HOME.TODOLIST.QUICKSETUP.4': '常用测试名单',
  'HOME.TODOLIST.QUICKSETUP.4.DESC':
    '设置测试白名单列表，在每次活动发布前快速验证',
  'HOME.TODOLIST.QUICKSETUP.11': '账号设置',
  'HOME.TODOLIST.QUICKSETUP.11.DESC': '设置双因素验证和时区偏好',
  'HOME.TODOLIST.APPROVAL': '待审批',
  'HOME.TODOLIST.OVER': '您已完成所有的待办事项',
  'HOME.TODOLIST.APPROVAL.DESC': '查看详情',
  'HOME.FEEDBACK.BTN': '反馈建议',
  'HOME.FEEDBACK.TITLE': '帮助我们改进SmartLink 😀 ',
  'HOME.FEEDBACK.TITLE.LABEL': '标题',
  'HOME.FEEDBACK.TITLE.REQUIRED.MSG': '请输入标题',
  'HOME.FEEDBACK.DESCRIPTION.LABEL': '问题描述',
  'HOME.FEEDBACK.SCREENSHOTS.LABEL': '截图',
  'HOME.FEEDBACK.SCREENSHOTS.TIPS':
    '仅支持JPG,PNG和GIF格式，最多上传3张截图，每张大小不超过5MB',
  'HOME.FEEDBACK.SCREENSHOTS.SIZE.LIMIT.MSG': '文件大小不能超过 {sizeLimit}',
  'HOME.FEEDBACK.SCREENSHOTS.MAX.FILE.LIMIT.MSG': '已达到最大上传图片数量',
  'HOME.FEEDBACK.SCREENSHOTS.UPLOAD.FAIL.MSG': '上传失败',
  'HOME.FEEDBACK.TITLE.PLACEHOLDER': '简单描述您的问题或建议',
  'HOME.FEEDBACK.DESCRIPTION.PLACEHOLDER':
    '详细描述您遇到的问题或建议，如果是错误报告，请尽可能清晰描述重现的步骤。',
  'HOME.FEEDBACK.CATEGORY.LABEL': '分类',
  'HOME.FEEDBACK.CATEGORY.OPTION.BUG.REPORT': '错误报告',
  'HOME.FEEDBACK.CATEGORY.OPTION.FEATURE.REQUEST': '功能建议',
  'HOME.FEEDBACK.CATEGORY.OPTION.USABILITY.ISSUE': '用户体验问题',
  'HOME.FEEDBACK.CATEGORY.OPTION.VISUAL.PROBLEM': '界面视觉问题',
  'HOME.FEEDBACK.CATEGORY.OPTION.QUESTION.HELP': '咨询与帮助',
  'HOME.FEEDBACK.CATEGORY.OPTION.OTHERS': '其他',
  'HOME.FEEDBACK.SUBMIT.SUCCESS': '提交成功，感谢反馈',
  'HOME.FEEDBACK.SUBMIT.TIPS.MSG': '请填写必填项',
  'HOME.ANNOUNCEMENT.SYSTEM.TITLE': '系统通知',
  'HOME.ANNOUNCEMENT.REMINDER': '不再提醒	',
  'HOME.ANNOUNCEMENT.TEAM': 'SmartLink团队',
  'HOME.ANNOUNCEMENT.VERSION.UPDATE': '新功能',

  // 首页重构
  'HOME.SEND.EMAIL': '发送邮件',
  'HOME.QUICK.ACTION': '快捷入口',
  'HOME.QUICK.ACTION.ADD.CONTACTS.CSV': '通过csv导入联系人',
  'HOME.QUICK.ACTION.ADD.TEMPLATE.MARKETING': '创建营销邮件模板',
  'HOME.QUICK.ACTION.ADD.SEGMENT': '创建用户分层',
  'HOME.COMPAIGNS.TAB.EMAIL': '邮箱',
  'HOME.COMPAIGNS.TAB.WHATSAPP': 'WhatsApp',
  'HOME.COMPAIGNS.MORE': '更多',
  'HOME.COMPAIGNS.TITLE': '近期活动表现',
  'HOME.COMPAIGNS.NAME': '活动名称',
  'HOME.COMPAIGNS.CATEGORY': '分类',
  'HOME.COMPAIGNS.STATUS': '状态',
  'HOME.COMPAIGNS.RECIPIENTS': '收件人',
  'HOME.COMPAIGNS.SENT': '已发送',
  'HOME.COMPAIGNS.DELIVERY.RATE': '送达率',
  'HOME.COMPAIGNS.OPEN.RATE': '打开率',
  'HOME.COMPAIGNS.CTOR': '打开点击率',
  'HOME.COMPAIGNS.UNSUBSCRIBE.RATE': '取订率',
  'HOME.COMPAIGNS.READ.RATE': '已读率',
  'HOME.COMPAIGNS.REPLIED.RATE': '回复率',
  'HOME.COMPAIGNS.EMPTT.TITLE': '尚无活动',
  'HOME.COMPAIGNS.EMPTT.DESC':
    '创建您的第一个活动，与玩家互动并跟踪他们的反馈。',
  'HOME.COMPAIGNS.EMPTT.CREATE.EMAIL': '创建首个邮件活动',
  'HOME.COMPAIGNS.EMPTT.CREATE.WHATSAPP': '创建首个WhatsApp活动',
  'HOME.COMPAIGNS.NO.OERMISSION.TITLE': '欢迎使用 WhatsApp！',
  'HOME.COMPAIGNS.NO.OERMISSION.DESC':
    '在开始前，请联系 SmartLink 团队协助配置您的发件号码。',
  'HOME.COMPAIGNS.NO.OERMISSION.LINK':
    '您也可以先查看<a class="color-primary font-poppins" href="{url}" target="_blank" style="text-decoration: none;">WhatsApp 使用指南</a>。',
  'HOME.CONTACTS.LEAD.TITLE': '尚无联系人',
  'HOME.CONTACTS.LEAD.DESC': '导入后即可查看玩家数量变化趋势。',
  'HOME.CONTACTS.LEAD.CREATE': '导入联系人',
  'HOME.CONTACTS.TREND.TITLE': '联系人变化',
  'HOME.CONTACTS.ALL.NUMBER': '联系人数量',
  'HOME.CONTACTS.SUBSCRIBERS': '订阅用户总量',
  'HOME.CONTACTS.CONTACTS.BREAKDOWN.TITLE': '联系人分布',
  'HOME.CONTACTS.ALL': '所有联系人',
  'HOME.CONTACTS.SUB': '所有订阅联系人',
};
